import { Components } from "@/app/(components)/_components/Components";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { ModalType } from "@/app/(components)/generics/Modal/Modal";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKeyCallAnalysis as TKey } from "@/app/translations/keys/TKeyCallAnalysis";
import { useT } from "@/app/translations/useT";
import { ProjectCallsRecommendationKind } from "@/app/types/call/CallAnalysis";
import styles from "./AnalysisRecommendationCard.module.css";

type Props = {
  action: { title: string };
  index: number;
  projectId: number;
  lang: string;
  kind: ProjectCallsRecommendationKind;
};

export default function AnalysisRecommendationCard(props: Props) {
  const T = useT();
  const { action, index, projectId, lang, kind } = props;

  const handleOpenDetail = () => {
    ModalStore.getState().openModal(
      Components.AnalysisRecommendationDetail,
      action.title,
      { projectId, index, title: action.title, lang, kind },
      ModalType.MEDIUM,
    );
  };

  return (
    <div className={styles.item} onClick={handleOpenDetail}>
      <div className={styles.itemStart}>
        <div className={styles.itemBadges}>
          {/* <span className={styles.badge}>{index + 1}</span> */}
          <span className={styles.aiBadge}>
            <IconSparkles size={9} color="currentColor" />
            <span>{T(TKey.CALL_ANALYSIS_RECO_AI)}</span>
          </span>
        </div>
        <span className={styles.title}>{action.title}</span>
      </div>
      <span className={styles.arrow}>&rarr;</span>
    </div>
  );
}
